import CssBaseline from "@mui/material/CssBaseline";
import GlobalStyles from "@mui/material/GlobalStyles";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { createBrowserHistory } from "history";
import { Provider } from "react-redux";

import ErrorBoundary from "./core/components/App/ErrorBoundary/ErrorBoundary";
import Notifier from "./core/components/App/Notifier/Notifier";
import Init from "./core/components/Init/Init";
import configureStore from "./core/redux/store/configureStore";
import theme from "./core/utilities/theme";
import styles from "./index.styles";
import { SequenceAnalyzer } from "./SequenceAnalyzer.tsx";

const browserHistory = createBrowserHistory();
const { appStore } = configureStore(browserHistory);

const SequenceAnalyzerPage = () => {
  return (
    <Provider store={appStore}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <GlobalStyles styles={styles} />
          <ErrorBoundary>
            {/* Can't have a router inside a router */}
            {/* <Router history={appHistory} basename={clientUrlBasePath()}> */}
            <Notifier />
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Init>
                <SequenceAnalyzer />
              </Init>
            </LocalizationProvider>
            {/* </Router> */}
          </ErrorBoundary>
        </ThemeProvider>
      </StyledEngineProvider>
    </Provider>
  );
};

export default SequenceAnalyzerPage;
